export interface SystemActivityLog {
  id: string;
  activityType: string;
  userId: string;
  userName: string;
  /** Local-time ISO string — the date interceptor has already shifted it off UTC. */
  createdAt: string;
  lastModified?: string | null;
  additionalInfos?: SystemActivityAdditionalInfo[] | null;
}

export interface SystemActivityAdditionalInfo {
  id: string;
  systemActivityId: string;
  key: string;
  value: string;
}

export interface SystemActivityType {
  id: string;
  activityType: string;
}

/**
 * Mirrors the backend `SortBy` enum, which is shared by every report endpoint.
 * Only the members below change the order of system activity — the endpoint accepts
 * the other values and then falls back to sorting by `createdAt`.
 */
export enum SystemActivitySortBy {
  Activity = 0,
  Date = 2,
  UserName = 3
}

/** Mirrors the backend `SortOrder` enum. */
export enum SystemActivitySortOrder {
  Ascending = 0,
  Descending = 1
}

export interface SystemActivityLogQuery {
  /** `null` leaves every activity type in the result. */
  activityType: string | null;
  /** `yyyy-MM-dd`. `null` leaves that end of the range open. */
  fromDate: string | null;
  toDate: string | null;
  pageNumber: number;
  pageSize: number;
  sortBy: SystemActivitySortBy;
  sortOrder: SystemActivitySortOrder;
}

export interface SystemActivityLogPage {
  logs: SystemActivityLog[];
  /** The endpoint reports no total count, so this is probed by over-fetching a row. */
  hasNextPage: boolean;
}
